module.exports = {
	crystalApiToken: "cefb5f8db67511cb9908ecc8bc954a57",
	coachingLink: "https://calendly.com/kate-oneil1/teaming-coaching-call",
	demoLink: "https://calendly.com/kate-oneil1/30-minute-meeting",
	// FEATUREFLAG
	showStripeIntegration: true,
	permitMobileMenu: true,
	enableEmailSignup: true,
	enableTranscriptionBot: true,
	enableDeferOneOnOneInvitation: false,
	enableSaveDraftKeyResult: false,
	enableRecommendedActionItems: true,
	enableTranscriptionRating: false,
	enableRecurrence: true,
	// ZOOM OAUTH FEATURE FLAG
	enableZoomOauth: true,
	zoomOauthUrl: "https://zoom.us/oauth/authorize",
};
